import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type {
  Amenity,
  Area,
  PropertyType,
  Season,
} from '@/api/istaff/referenceData';

type ReferenceDataState = {
  amenities: Amenity[];
  areas: Area[];
  propertyTypes: PropertyType[];
  seasons: Season[];
  loading: boolean;
  loaded: boolean;
  loadedLocale: string | null;
};

const initialState: ReferenceDataState = {
  amenities: [],
  areas: [],
  propertyTypes: [],
  seasons: [],
  loading: false,
  loaded: false,
  loadedLocale: null,
};

export const referenceDataSlice = createSlice({
  name: 'referenceData',
  initialState,
  reducers: {
    setReferenceDataLoading: (state) => {
      state.loading = true;
    },
    setReferenceData: (
      state,
      {
        payload,
      }: PayloadAction<{
        amenities: Amenity[];
        areas: Area[];
        propertyTypes: PropertyType[];
        seasons: Season[];
        locale: string;
      }>,
    ) => {
      state.amenities = payload.amenities;
      state.areas = payload.areas;
      state.propertyTypes = payload.propertyTypes;
      state.seasons = payload.seasons;
      state.loading = false;
      state.loaded = true;
      state.loadedLocale = payload.locale;
    },
    setReferenceDataFailed: (state) => {
      state.loading = false;
    },
  },
});

export const { reducer: referenceDataReducer } = referenceDataSlice;
